export default __webpack_public_path__ + "locales/en/Payments.json?hash=c38d12a5001997e729a6d3341e3aa0ff";